export default __webpack_public_path__ + "static/media/Whitlist.4e5f274c.png";